import React from 'react';
import RealEstateManagingPartnerDashboardNew from './RealEstateManagingPartnerDashboardNew';

// Simplified Dashboard - Always renders the Real Estate Managing Partner Dashboard
const Dashboard = () => {
  return <RealEstateManagingPartnerDashboardNew />;
};

export default Dashboard;
